module.exports = __webpack_public_path__ + "img/enroll_vf_jbsmd.6f8ad2a8.png";